import Vue from 'vue';
import Router from 'vue-router';

//解决编程式路由往同一地址跳转时会报错的情况
const originalPush = Router.prototype.push;
const originalReplace = Router.prototype.replace;
//push
Router.prototype.push = function push(location, onResolve, onReject) {
    if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject);
    return originalPush.call(this, location).catch(err => err);
};
//replace
Router.prototype.replace = function push(location, onResolve, onReject) {
    if (onResolve || onReject) return originalReplace.call(this, location, onResolve, onReject);
    return originalReplace.call(this, location).catch(err => err);
};

const Home = resolve => require.ensure([], () => resolve(require('@/views/home/home.vue')), 'home');
const Search = resolve => require.ensure([], () => resolve(require('@/views/search/search.vue')), 'search');
const Favorite = resolve => require.ensure([], () => resolve(require('@/views/favorite/favorite.vue')), 'favorite');
const CourseDetail = resolve => require.ensure([], () => resolve(require('@/views/course/detail.vue')), 'courseDetail');
const TipsDetail = resolve => require.ensure([], () => resolve(require('@/views/tips/detail.vue')), 'tipsDetail');

Vue.use(Router);


export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/help-center/',
      name: 'home',
      component: Home,
      meta: {
        showFooter: true,
        showNav: true,
      }
    },
    {
      path: '/help-center/search/:keyword',
      name: 'search',
      component: Search,
      meta: {
        showNav: true,
      }
    },
    {
      path: '/help-center/favorite',
      name: 'favorite',
      component: Favorite,
      meta: {
        showNav: true,
      }
    },
    {
      path: '/help-center/course/:id',
      name: 'courseDetail',
      component: CourseDetail,
      meta: {
        showNav: false
      }
    },
    {
      path: '/help-center/tips/:id',
      name: 'tipsDetail',
      component: TipsDetail,
      meta: {
        showNav: false
      }
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js